export interface NotificationItem {
	id: string;
	subject: string;
	body: string;
	organization: object;
	status: string;
	sender: {
		firstName: string;
		lastName: string;
		email: string;
	};
	archivedAt?: string;
	trashedAt?: string;
	readAt?: string;
	sentAt: string;
}

export enum MessageCenterNotificationsListType {
	INBOX = 'inbox',
	TRASH = 'trash'
}

export interface NotificationStoreData {
	id: string;
	body?: string;
	sender: {
		firstName: string;
		lastName: string;
		email: string;
	};
	organization?: {
		id?: string;
		name?: string;
	};
	sentAt?: string;
	status: string;
	readAt?: string;
	archivedAt?: string;
	trashedAt?: string;
	subject: string;
	isRead?: boolean;
	isDeleted?: boolean;
	notificationlisttype?: string;
}

export interface NotificationState {
	notifications: NotificationStoreData[];
}

export enum NotificationFilterEnum {
	READ = 'read',
	UNREAD = 'unread',
	ARCHIVED = 'archived',
	TRASHED = 'trashed'
}

export const CHUNK_SIZE = 100;

export interface GetNotificationParams {
	application: string;
	next?: string;
	filter?: string;
}
